export default __webpack_public_path__ + "static/media/npsMain.d044f817.png";